import React from 'react';

const ResumeContext = React.createContext({
  resumeState: {},
  templateState: {},
  resumeStateDispatch: () => {},
});

export default ResumeContext;